// --- 自学成才 --- //

export default [
  {
    name: 'selfStudyApplyInfo',
    path: '/selfStudySystem/applyInfo',
    meta: { title: '自学成才报名管理' },
    component: require('business/selfStudySystem/applyInfoManagement/applyInfo/list.vue').default
  }

]
